import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom';
import $ from "jquery";
import axios from 'axios';
import db from '../dbconn';
import {API_ROOT} from './../api-config';
import Modal from 'react-responsive-modal';
import fetch from "isomorphic-fetch";
import Swal from "sweetalert2";
import {withTranslation} from 'react-i18next';
import i18n from '../i18n';

class edit_profile extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            redirect: false,
            nosessionredirect: false,
            open: false,
            customerId: this.props.match.params.custId,
            categoryList: [],
            windowHeight: 0,
            customerToken: '',
            swalButton: '',
            phone: ''
        };
        this.updateState = this.updateState.bind(this);
    };

    handleChange = e => {

        this.setState({phone: this.normalizeInput($(e.target).val(), this.state.phone)});
    };

    normalizeInput = (value, previousValue) => {
        if (!value) return value;
        var currentValue = value.replace(/[^\d]/g, '');
        var cvLength = currentValue.length;

        if (!previousValue || value.length > previousValue.length) {
            if (cvLength < 4) return currentValue;
            if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
            return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
        }
    };
    onOpenModal = () => {
        this.setState({open: true});

    };
    onCloseModal = () => {
        this.setState({open: false});
    };

    updateState(e) {
        this.setState({});
    }

    componentDidMount() {

        document.title = "Edit Profile - " + localStorage.getItem("store_name") + " - Order Anywhere";

        var primaryColor = localStorage.getItem("store_primary_color");

        if (primaryColor != null) {
            document.documentElement.style.setProperty('--primaryColor', primaryColor);
        }
        var secondaryColor = localStorage.getItem("store_secondary_color");


        if (secondaryColor != null) {
            document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
        }
        var lightColor = localStorage.getItem("store_light_color");

        if (lightColor != null) {
            document.documentElement.style.setProperty('--lightColor', lightColor);
        }

        var buttonColor = localStorage.getItem("store_button_color");

        if (buttonColor != null) {
            document.documentElement.style.setProperty('--buttonColor', buttonColor);
        }


        var height = $(window).height();
        this.setState({windowHeight: height});

        $('#editProfileBtn').click(e => {

            var allOkay = true;
            var firstname = $('#custFirstNameTxt').val();
            var lastname = $('#custLastNameTxt').val();
            var email = $('#custEmailTxt').val();
            var phone = $('#custPhoneTxt').val();
            var address = $('#custAddressTxt').val();
            var city = $('#custCityTxt').val();
            var state = $('#custStateTxt').val();
            var zip = $('#custZipTxt').val();

            if (firstname == '' ||
                firstname == null ||
                lastname == '' ||
                lastname == null ||
                phone == '' ||
                phone == null ||
                address == '' ||
                address == null ||
                city == '' ||
                city == null ||
                state == '' ||
                state == null ||
                zip == '' ||
                zip == null) {

                allOkay = false;


                this.state.swalButton.fire({title: i18n.t('field_validation'), allowOutsideClick: false});
            }

            if (allOkay) {
                this.onOpenModal();
                axios.post(API_ROOT + '/updateprofile', {
                    customer_firstname: firstname,
                    customer_lastname: lastname,
                    customer_email: email,
                    customer_phone: phone,
                    customer_address: address,
                    customer_city: city,
                    customer_state: state,
                    customer_zip: zip,
                    customer_id: this.state.customerId,
                    customer_token: this.state.customerToken
                })
                    .then(response => {

                        this.onCloseModal();

                        if (response.data.status == 1) {

                            var dbconn = new db();

                            dbconn.getAll().then(data => {
                                var oldData = data;

                                dbconn.deleteAll();

                                dbconn.set({
                                    customer_id: oldData[0].customer_id,
                                    customer_token: oldData[0].customer_token,
                                    customer_firstname: firstname,
                                    customer_lastname: lastname,
                                    customer_email: email,
                                    customer_address: address,
                                    customer_city: city,
                                    customer_state: state,
                                    customer_zipcode: zip,
                                    customer_phone: phone
                                });
                            });

                            this.setState({redirect: true});
                        } else {
                            this.state.swalButton.fire({title: response.data.message, allowOutsideClick: false});

                        }
                    }).catch(error => {
                    this.onCloseModal();
                    console.log(error);
                });
            }

        });
    }

    componentWillMount() {
        if(!localStorage.getItem("store_language")){
            localStorage.setItem("store_language","en")
        }
        i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
        });

        this.setState({
            swalButton: Swal.mixin({
                customClass: {
                    confirmButton: 'link_button',
                    cancelButton: 'link_button'
                },
                buttonsStyling: false,
            })
        });


        $(".custom-select").each(function () {
            $(this).wrap("<span className='select-wrapper'></span>");
            $(this).after("<span className='holder'></span>");
        });
        $(".custom-select").change(function () {
            var selectedOption = $(this).find(":selected").text();
            $(this).next(".holder").text(selectedOption);
        }).trigger('change');

        var dbconn = new db();

        dbconn.getAll().then(data => {

            if (!data || data.length < 1 || sessionStorage.getItem('guestFlag') == 'Y') {
                this.setState({nosessionredirect: true});
            } else {

                this.onOpenModal();
                var customer_id = data[0].customer_id;
                var customer_token = data[0].customer_token;
                var url = API_ROOT + '/fetchprofile?customer_id=' + customer_id + '&customer_token=' + customer_token;

                this.setState({customerToken: data[0].customer_token});
                fetch(url)
                    .then(response => {
                        return response.json();
                    })
                    .then(customerData => {

                        this.onCloseModal();
                        if (customerData.status == 1) {

                            var custData = customerData.customer_data[0];

                            $('#custFirstNameTxt').val(custData.customer_firstname);
                            $('#custLastNameTxt').val(custData.customer_lastname);
                            $('#custEmailTxt').val(custData.customer_email);
                            $('#custPhoneTxt').val(custData.customer_phone);
                            this.setState({phone: custData.customer_phone});
                            $('#custAddressTxt').val(custData.customer_address);
                            $('#custCityTxt').val(custData.customer_city);
                            $('#custStateTxt').val(custData.customer_state);
                            $('#custZipTxt').val(custData.customer_zipcode);
                        }
                    });

                var categroyUrl = API_ROOT + '/fetchcategorylist?customer_id=' + customer_id + '&customer_token=' + customer_token + '&store_id=' + localStorage.getItem('store_id');

                fetch(categroyUrl)
                    .then(response => {
                        return response.json();
                    })
                    .then(categoryData => {

                        this.onCloseModal();
                        if (categoryData.status == 1) {
                            this.setState({categoryList: categoryData.category_data});

                            var nav = window.$('#nav-main').okayNav();
                            nav.okayNav('recalcNav');
                        }
                    });
            }
        });
    }

    render() {
        const {t} = this.props;
        const {open} = this.state;

        if (this.state.nosessionredirect) {
            return <Redirect to='/'/>;
        }

        if (this.state.redirect) {
            return <Redirect to='/profile'/>;
        }

        return (
            <div className="mainContainer">
                <header className="fixedHeader">
                    <div className="col-md-12 col-sm-12 col-xs-12 previous-link">
                        <Link to="/profile"></Link>
                        <h2 className="text-center"><strong>{t('profile')}</strong></h2>
                    </div>
                </header>
                <div className="mt-white h-100 middleContent">
                    <div className="simple-box m-b-0 p-b-35 bkg-white h-100" style={{paddingBottom: "150px"}}>
                        <div className="form-box w-75 div-center">
                            <div className="header-title">
                                <h2 className="text-center font-size-20 m-0">{t('edit_profile')}</h2>

                            </div>

                            <div className="form-group">
                                <label>{t('first_name')}*</label>
                                <input type="text" className="form-control" name="custFirstNameTxt"
                                       id="custFirstNameTxt"/>
                            </div>
                            <div className="form-group">
                                <label>{t('last_name')}</label>
                                <input type="text" className="form-control" name="custLastNameTxt"
                                       id="custLastNameTxt"/>
                            </div>
                            <div className="form-group m_b_10">
                                <label>{t('email_address')}*</label>
                                <input type="text" className="form-control m-b-0" name="custEmailTxt" id="custEmailTxt"
                                       readOnly={true}/>
                                <small>{t('we_never_share_your_email')}</small>
                            </div>
                            <div className="form-group m_b_10">
                                <label>{t('phone_number')}*</label>
                                <input type="text" className="form-control m-b-0" name="custPhoneTxt" id="custPhoneTxt"

                                       value={this.state.phone || ''}
                                       onChange={this.handleChange} required/>
                                <small>{t('phone_disclaimer')}</small>
                            </div>
                            <div className="form-group m_b_10">
                                <label>{t('address')}*</label>
                                <input type="text" className="form-control m-b-0" name="custAddressTxt"
                                       id="custAddressTxt"/>
                            </div>
                            <div className="form-group third-5-column">
                                <label>{t('city')}</label>
                                <input type="text" className="form-control" name="custCityTxt" id="custCityTxt"
                                       required/>
                            </div>
                            <div className="form-group  third-3-column">
                                <label>{t('state')}</label>

                                <select className="form-control custom-select radius-0 " id="custStateTxt"
                                        name="custStateTxt"
                                        required>

                                    <option value="">{t('select_any')}</option>
                                    <option value="AL">Alabama</option>
                                    <option value="AK">Alaska</option>
                                    <option value="AZ">Arizona</option>
                                    <option value="AR">Arkansas</option>
                                    <option value="CA">California</option>
                                    <option value="CO">Colorado</option>
                                    <option value="CT">Connecticut</option>
                                    <option value="DE">Delaware</option>
                                    <option value="DC">District Of Columbia</option>
                                    <option value="FL">Florida</option>
                                    <option value="GA">Georgia</option>
                                    <option value="HI">Hawaii</option>
                                    <option value="ID">Idaho</option>
                                    <option value="IL">Illinois</option>
                                    <option value="IN">Indiana</option>
                                    <option value="IA">Iowa</option>
                                    <option value="KS">Kansas</option>
                                    <option value="KY">Kentucky</option>
                                    <option value="LA">Louisiana</option>
                                    <option value="ME">Maine</option>
                                    <option value="MD">Maryland</option>
                                    <option value="MA">Massachusetts</option>
                                    <option value="MI">Michigan</option>
                                    <option value="MN">Minnesota</option>
                                    <option value="MS">Mississippi</option>
                                    <option value="MO">Missouri</option>
                                    <option value="MT">Montana</option>
                                    <option value="NE">Nebraska</option>
                                    <option value="NV">Nevada</option>
                                    <option value="NH">New Hampshire</option>
                                    <option value="NJ">New Jersey</option>
                                    <option value="NM">New Mexico</option>
                                    <option value="NY">New York</option>
                                    <option value="NC">North Carolina</option>
                                    <option value="ND">North Dakota</option>
                                    <option value="OH">Ohio</option>
                                    <option value="OK">Oklahoma</option>
                                    <option value="OR">Oregon</option>
                                    <option value="PA">Pennsylvania</option>
                                    <option value="RI">Rhode Island</option>
                                    <option value="SC">South Carolina</option>
                                    <option value="SD">South Dakota</option>
                                    <option value="TN">Tennessee</option>
                                    <option value="TX">Texas</option>
                                    <option value="UT">Utah</option>
                                    <option value="VT">Vermont</option>
                                    <option value="VA">Virginia</option>
                                    <option value="WA">Washington</option>
                                    <option value="WV">West Virginia</option>
                                    <option value="WI">Wisconsin</option>
                                    <option value="WY">Wyoming</option>
                                </select>


                            </div>
                            <div className="form-group third-4-column">
                                <label>{t('zip_code')}</label>
                                <input type="text" className="form-control" name="custZipTxt" id="custZipTxt"/>
                            </div>


                            <div className="clearfix"></div>
                            <br/>

                            <div className="form-group m-t-30 btn-red m-b-30">
                                <input type="button" name="editProfileBtn" id="editProfileBtn"
                                       value={t('update_profile')}/>

                            </div>

                        </div>
                    </div>
                </div>

                <Modal closeOnEsc={false} closeOnOverlayClick={false} showCloseIcon={false} open={open}
                       onClose={this.onCloseModal} center>
                    <h2>&nbsp;&nbsp;&nbsp;&nbsp;{t('loading')}...&nbsp;&nbsp;&nbsp;&nbsp;</h2>

                    <p style={{textAlign: 'center'}}>
                        <img width={'40'} height={'40'} src={'/img/loader.gif'}/>
                    </p>
                </Modal>
                <div className="clearfix"></div>
            </div>
        );
    }
}

export default withRouter(withTranslation()(edit_profile));



// WEBPACK FOOTER //
// ./src/view_components/edit_profile.js